// Exact aliases of existing translated interface copy.
export const reviewedFallbackTranslations = {
  "es": {
    "dashboard.briefyOnline": "En línea",
    "clock.kioskBadge": "Reloj Checador",
    "clock.kioskTitle": "Tu URL de Kiosko",
    "clock.kioskDesc": "Abre este link en cualquier tablet o teléfono en la entrada. Tus empleados marcan con su PIN de 4 dígitos.",
    "clock.copied": "¡Copiado!",
    "clock.copy": "Copiar",
    "clock.open": "Abrir",
    "clock.qr": "QR",
    "clock.totalActive": "Empleados activos",
    "clock.inside": "Adentro ahora",
    "clock.eventsToday": "Marcajes hoy",
    "clock.hoursWeek": "Horas 7d",
    "clock.insideNow": "Adentro ahora",
    "clock.noOneInside": "Nadie ha marcado entrada hoy.",
    "clock.since": "desde",
    "clock.markOut": "Salida",
    "clock.notInside": "Fuera / sin marcar",
    "clock.allInside": "¡Todos están adentro!",
    "clock.noPin": "sin PIN",
    "clock.markIn": "Entrada",
    "clock.weeklySummary": "Horas últimos 7 días",
    "clock.noHours": "Sin horas registradas aún.",
    "clock.tEmployee": "Empleado",
    "clock.tHours": "Horas",
    "clock.tOvertime": "Extra",
    "clock.tDays": "Días",
    "clock.openReport": "Reporte de productividad",
    "clock.refresh": "Refrescar",
    "clock.qrTitle": "Escanea para abrir el Kiosko",
    "clock.qrDesc": "Apunta la cámara del tablet/celular de la entrada.",
    "tasks.errCreate": "No se pudo crear la tarea",
    "tasks.errUpdate": "No se pudo actualizar",
    "tasks.confirmDelete": "¿Borrar esta tarea?",
    "tasks.errDelete": "No se pudo borrar",
    "tasks.allStatus": "Todos los estados",
    "tasks.status.pending": "Pendiente",
    "tasks.status.in_progress": "En progreso",
    "tasks.status.completed": "Completada",
    "tasks.allEmployees": "Todos los empleados",
    "tasks.newTask": "Asignar tarea",
    "tasks.empty": "Sin tareas",
    "tasks.emptyHint": "Asigna labores a tus empleados con el botón \"Asignar tarea\".",
    "tasks.selectEmployee": "-- Seleccionar empleado --",
    "tasks.titlePh": "Título de la tarea",
    "tasks.descPh": "Descripción (opcional)",
    "tasks.priority.low": "Prioridad baja",
    "tasks.priority.medium": "Prioridad media",
    "tasks.priority.high": "Prioridad alta",
    "tasks.saving": "Guardando...",
    "paystubSign.confirmCancel": "¿Cancelar la solicitud de firma y generar una nueva?",
    "paystubSign.btnTitle": "Solicitar firma digital",
    "paystubSign.title": "Firma Digital",
    "paystubSign.intro": "Genera un link único para que el empleado firme su recibo desde su celular. La firma queda registrada con fecha, hora, IP, GPS y hash SHA-256 para auditoría legal.",
    "paystubSign.generating": "Generando...",
    "paystubSign.generate": "Generar link de firma",
    "paystubSign.signed": "Firmado",
    "paystubSign.signedBy": "Firmado por",
    "paystubSign.signedAt": "Fecha",
    "paystubSign.pending": "Esperando firma del empleado",
    "paystubSign.shareInstructions": "Comparte este link con el empleado. Apenas firme verás la confirmación aquí.",
    "paystubSign.linkLabel": "Link de firma",
    "paystubSign.copied": "¡Copiado!",
    "paystubSign.copy": "Copiar link",
    "paystubSign.openLink": "Abrir link",
    "paystubSign.retry": "Reintentar firma",
    "paystubSign.regenerate": "Cancelar y regenerar",
    "paystubSign.qrHint": "El empleado escanea con su celular.",
    "report.errExcel": "No se pudo exportar Excel",
    "report.errPdf": "No se pudo exportar PDF",
    "report.badge": "Reporte",
    "report.title": "Productividad",
    "report.last7": "Últimos 7 días",
    "report.last14": "Últimos 14 días",
    "report.last30": "Últimos 30 días",
    "report.loading": "Generando reporte...",
    "report.noData": "No hay datos para mostrar",
    "report.totalHours": "Horas totales",
    "report.overtime": "Horas extras",
    "report.tasksDone": "Tareas completadas",
    "report.workedRatio": "Empleados activos",
    "report.hoursPerDay": "Horas trabajadas por día",
    "report.noHoursYet": "Aún no hay horas registradas en este rango.",
    "report.hours": "Horas",
    "report.top": "Top empleados",
    "report.tasks": "tareas",
    "report.detailTitle": "Desglose por empleado",
    "report.noEmployees": "Sin actividad de empleados.",
    "report.tEmp": "Empleado",
    "report.tHours": "Horas",
    "report.tOvertime": "Extras",
    "report.tDays": "Días",
    "report.tTasks": "Tareas",
    "report.tProd": "Productividad",
    "report.tip": "Exporta este reporte para liquidar nómina o compartir con tu contador."
  },
  "en": {
    "dashboard.briefyOnline": "Online",
    "clock.kioskBadge": "Time clock",
    "clock.copy": "Copy",
    "clock.markOut": "Clock out",
    "clock.markIn": "Clock in",
    "clock.tEmployee": "Employee",
    "clock.tHours": "Hours",
    "clock.refresh": "Refresh",
    "tasks.allStatus": "All statuses",
    "tasks.status.pending": "Pending",
    "tasks.status.in_progress": "In progress",
    "tasks.selectEmployee": "-- Select employee --",
    "tasks.descPh": "Description (optional)",
    "tasks.saving": "Saving...",
    "paystubSign.generating": "Generating...",
    "paystubSign.signed": "Signed",
    "paystubSign.signedBy": "Signed by",
    "paystubSign.signedAt": "Date",
    "report.badge": "Report",
    "report.noData": "No data to display",
    "report.hours": "Hours",
    "report.tasks": "tasks",
    "report.tEmp": "Employee",
    "report.tHours": "Hours",
    "report.tTasks": "Tasks"
  },
  "pt": {
    "dashboard.briefyOnline": "Online",
    "clock.kioskBadge": "Relógio de ponto",
    "clock.markOut": "Saída",
    "clock.tEmployee": "Funcionário",
    "clock.refresh": "Atualizar",
    "tasks.allStatus": "Todos os status",
    "tasks.status.pending": "Pendente",
    "tasks.status.in_progress": "Em andamento",
    "tasks.selectEmployee": "-- Selecionar funcionário --",
    "tasks.descPh": "Descrição (opcional)",
    "tasks.saving": "Salvando...",
    "paystubSign.signed": "Assinado",
    "paystubSign.signedBy": "Assinado por",
    "paystubSign.signedAt": "Data",
    "report.badge": "Relatório",
    "report.tasks": "tarefas",
    "report.tEmp": "Funcionário",
    "report.tTasks": "Tarefas"
  },
  "fr": {
    "dashboard.briefyOnline": "En ligne",
    "clock.kioskBadge": "Pointeuse",
    "clock.copy": "Copier",
    "clock.markOut": "Départ",
    "clock.markIn": "Arrivée",
    "clock.tEmployee": "Employé",
    "clock.tHours": "Heures",
    "clock.refresh": "Actualiser",
    "tasks.allStatus": "Tous les statuts",
    "tasks.status.pending": "En attente",
    "tasks.status.in_progress": "En cours",
    "tasks.selectEmployee": "-- Sélectionner un employé --",
    "tasks.descPh": "Description (facultative)",
    "tasks.saving": "Enregistrement...",
    "paystubSign.signed": "Signe",
    "paystubSign.signedBy": "Signe par",
    "paystubSign.signedAt": "Date",
    "report.badge": "Rapport",
    "report.noData": "Aucune donnée à afficher",
    "report.hours": "Heures",
    "report.tasks": "tâches",
    "report.tEmp": "Employé",
    "report.tHours": "Heures",
    "report.tTasks": "Tâches"
  }
};
